import React from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import './App.scss';
import videoFrame from './video-frame.png';

export function HomePage() {
  const navigate = useNavigate();

  return (
    <>
      <header>
        <div className="wrapper">
          <div id="logo-intro">
            <img src="underground-pizza-horiz-mark.png" alt="Underground Pizza" />
            <div id="intro-text">
              <h2>No Story is Too Small</h2>
              <p>We're not just looking for wild stories &mdash; we're looking for every piece of the Underground Pizza puzzle.</p>
              <p>Whether you called for your first order, told a friend about the secret number, or just felt the thrill of being in on something special, we want to hear from you.</p>
              <p>
                <strong>
                  Your memory is part of the legend. Share your <em>slice</em> of the story.
                </strong>
              </p>
            </div>
          </div>
          <div id="hero-video">
            <div id="video-frame" style={{ '--video-frame-url': `url(${videoFrame})` } as React.CSSProperties}>
              <video controls>
                <source src="ug-pizza-doc-interviews-cta.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <h2>Be a part of the Underground Pizza Story!</h2>
            <p>We're collecting stories to honor the legend of Underground Pizza. Share yours!</p>
            <button onClick={() => {
              navigate('/interview');
              window.scrollTo(0, 0);
            }}>Get Interviewed!</button>
          </div>
        </div>
      </header>
      <div id="social">
        <div className="wrapper">
          <div id="youtube">
            <a href="https://www.youtube.com/watch?v=bcdXmI-r3VQ&t=1s" target="_blank" rel="noreferrer">
              <img src="youtube-icon.svg" alt="YouTube" />
              <span>YouTube</span>
            </a>
          </div>
          <div id="facebook">
            <a href="https://www.facebook.com/profile.php?id=61559722024812" target="_blank" rel="noreferrer">
              <img src="facebook-icon.svg" alt="Facebook" />
              <span>Facebook</span>
            </a>
          </div>
          <div id="instagram">
            <a href="https://www.instagram.com/undergroundpizzadoc/" target="_blank" rel="noreferrer">
              <img src="instagram-icon.svg" alt="Instagram" />
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </div>
      <main>
        <div className="wrapper">
          <section className="panel about-panel">
            <h2>WHAT'S THIS ALL ABOUT?</h2>
            <p>
              It wasn't just pizza. It was a secret, a ritual, a late-night lifeline delivered from a shed in Hattiesburg. Underground Pizza wasn't on any map &mdash; you found it because someone
              trusted you with the number. And when you called, Scott didn't just take your order; he created an experience that was as much about the legend as it was about the food.
            </p>
            <p>
              Now, we're telling the story of Underground Pizza in all its chaotic, unforgettable glory. From those late-night cravings and drunken munchies to the thrill of being part of something
              hidden and special, we want to hear your story. Join us on <strong>January 25</strong> in Hattiesburg for a customer interview day. No story is too small, no memory too weird &mdash;
              this is your chance to be part of the legend.
            </p>
          </section>

          <section className="panel signup-panel">
            <h2>HOW TO SIGN UP</h2>
            <p>Getting involved is simple:</p>
            <ol>
              <li>Click the Button: Hit the big red "Get Interviewed!" button to get started.</li>
              <li>
                Fill Out the Form: Share your contact info and a few details about your Underground Pizza experience &mdash; whether it's a wild story, a late-night craving, or just your memory of
                that first bite.
              </li>
            </ol>
            <p>
              That's it! Once you've signed up, we'll be in touch to confirm your time slot for the interview day on <strong>January 25</strong> in Hattiesburg, MS.
            </p>
            <p>Don't miss your chance to help tell the Underground Pizza story and become part of the legend.</p>
          </section>

          <section className="panel privacy-panel">
            <h2>HOW WE'LL USE YOUR INFO</h2>
            <p>
              The information you share will only be used to contact you about participating in the Underground Pizza documentary. We respect your privacy and won't share your details with anyone
              else.
            </p>
            <img src="/home-slice.png" alt="Home Slice" />
          </section>
        </div>
      </main>
      <footer>
        <div className="wrapper">
          <div className="footer-content">
            <p className="copyright">&copy; {new Date().getFullYear()} Underground Pizza Documentary. All rights reserved.</p>
            <p className="easter-egg" title="Yeah, what do you want?">
              🍕
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Outlet />
    </div>
  );
}

export default App;
